"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classNames = _interopRequireDefault(require("../../util/classNames"));

require("./InputChip.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InputChip = function InputChip(_ref) {
  var _classnames;

  var label = _ref.label,
      tabIndex = _ref.tabIndex,
      color = _ref.color,
      message = _ref.message,
      errorMessage = _ref.errorMessage,
      interactive = _ref.interactive,
      invalid = _ref.invalid,
      onClick = _ref.onClick,
      onDelete = _ref.onDelete;
  var classes = (0, _classNames["default"])((_classnames = {}, _defineProperty(_classnames, color, color != null), _defineProperty(_classnames, "interactive", interactive), _defineProperty(_classnames, "invalid", invalid), _classnames));

  var deleteHandler = function deleteHandler(e) {
    e.stopPropagation();
    onDelete(e);
  };

  return /*#__PURE__*/_react["default"].createElement("span", {
    tabIndex: tabIndex,
    className: 'uin-input-chip ' + classes,
    onClick: onClick
  }, label, errorMessage && /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-chp-error"
  }, errorMessage), message && /*#__PURE__*/_react["default"].createElement("span", {
    className: "uin-chp-msg"
  }, message), onDelete && /*#__PURE__*/_react["default"].createElement("i", {
    className: "gcl-icon close-circle",
    onClick: deleteHandler
  }));
};

InputChip.propTypes = {
  label: _propTypes["default"].string.isRequired,
  tabIndex: _propTypes["default"].number,
  color: _propTypes["default"].oneOf(['blue', 'green']),
  message: _propTypes["default"].string,
  errorMessage: _propTypes["default"].string,
  interactive: _propTypes["default"].bool,
  invalid: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  onDelete: _propTypes["default"].func
};
var _default = InputChip;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/InputChip/InputChip.js
// module id = 695
// module chunks = 0